import { CustomerRpmAccount } from '../../store/CustomerRpmAccount';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

export const listCustomerRpmAccounts = (customerId: string, filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 25,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'accountNumber', direction: 'asc' }]
  };
  return apiService.callExternalApi<PaginatedResponse<CustomerRpmAccount>>({
    url: buildAdvancedQueryURL(mergedFilters, `customer-rpm-accounts/${customerId}`),
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
